import {setDeviceDescription} from "../../../api";
import React, {useEffect, useState} from "react";
import {KTSVG} from "../../../../../../_metronic/helpers";
import {ICommentProps} from "./Comment";
import {Modal} from "react-bootstrap-v5";
import Alert from "../../../../../components/alerts/Alert";

interface ICommentFormProps extends ICommentProps {
    show: boolean
    handleClose: (updatedDescription?: string | undefined) => void
}

/**
 * Форма комментария во всплывающем окне
 */
export const CommentForm = ({msisdn, description, show, handleClose}: ICommentFormProps) => {
    const [message, setMessage] = useState('')
    const [cardComment, setCardComment] = useState(description)
    const [isSubmitted, setIsSubmitted] = useState(false)

    useEffect(() => {
        const getResponse = async () => {
            if (msisdn) {
                const response = await setDeviceDescription(msisdn, cardComment)
                switch (response.status) {
                    case "ok":
                        return handleClose(cardComment)
                    case "error":
                        console.log(response)
                        setMessage("Сервер не смог обработать запрос. Попробуйте сохранить комментарий позднее.")
                        return false
                }
            }
        }

        isSubmitted && getResponse()
    }, [isSubmitted])  // eslint-disable-line react-hooks/exhaustive-deps

    /**
     * Сброс формы при открытии модального окна
     */
    const reset = () => {
        setMessage('')
        setIsSubmitted(false)
    }

    return (
        <Modal
            className='modal'
            role='dialog'
            aria-hidden='true'
            tabIndex='-1'
            show={show}
            dialogClassName="modal-dialog modal-dialog-scrollable w-350px"
            onShow={reset}
            onHide={handleClose}
        >
            <div className='modal-header py-4'>
                <h3>Комментарий к SIM-карте</h3>

                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={() => handleClose()}>
                    <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1'/>
                </div>
            </div>

            <div className='modal-body pt-5 px-10 center'>
                <div className="d-flex justify-content-between mb-5">
                        <textarea
                            className="form-control form-control-solid"
                            value={cardComment !== undefined ? cardComment : description}
                            style={{width: "100%", height: "80px"}}
                            onFocus={(event) => event.stopPropagation()}
                            onInput={(event) => setCardComment(event.currentTarget.value)}
                        >
                        </textarea>
                </div>
                <div className="d-flex justify-content-end">
                    <button className="btn btn-primary" onClick={() => setIsSubmitted(true)}>Сохранить</button>
                </div>
                <div>
                    {message && <Alert message={message}/>}
                </div>
            </div>
        </Modal>
    )
}
